// extracted by mini-css-extract-plugin
export default {"censuredContent":"payments_censuredContent__gKdcu","censuredText":"payments_censuredText__o7qNj"};